import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  logo: {
    height: '30px',
    width: '120px',
  },
  label: {
    textTransform: 'capitalize',
  },
}));
